import leave1 from './../../assets/decorations/leave_1.png'
import leave2 from './../../assets/decorations/leave_2.png'
import leave3 from './../../assets/decorations/leave_3.png'
import leave4 from './../../assets/decorations/leave_4.png'
import leave5 from './../../assets/decorations/leave_5.png'
import { Decoration } from '../decoration/decoration';


export const LeavesDecoration = () => {
    
    // do not dispaly for small screens

    return <>
    <div style={{position: "absolute", width: "100%", height: "100%"}}>
         <div style={{position: "relative", height: "100%", padding: "100px"}}>
         <Decoration src={leave3} additionalStyles={{bottom: "50%", right: "-120px", width:  "21vw",  transform: "rotate(-100deg)"}}/>
         <Decoration src={leave1} additionalStyles={{bottom: "23%", right: "-90px", width:  "21vw", transform: "rotate(-55deg)"}}/>
         <Decoration src={leave5} additionalStyles={{bottom: "-50px", right: "-70px", width: "21vw", transform: "rotate(-35deg)"}}/>
         <Decoration src={leave2} additionalStyles={{bottom: "-120px", left: "65%", width: "22vw", transform: "rotate(-10deg)"}}/>
         <Decoration src={leave4} additionalStyles={{bottom: "-100px", left: "50%", width: "22vw", transform: "rotate(-10deg)"}}/>
         <Decoration src={leave1} additionalStyles={{bottom: "-150px", left: "35%", width: "21vw", transform: "rotate(30deg)"}}/>
         <Decoration src={leave2} additionalStyles={{bottom: "-80px", left: "20%", width: "21vw", transform: "rotate(-10deg)"}}/>
         <Decoration src={leave5} additionalStyles={{bottom: "-100px", left: "7%", width: "21vw", transform: "rotate(50deg)"}}/>

         <Decoration src={leave1} additionalStyles={{bottom: "40%", left: "-50px", width:  "24vw", transform: "rotate(50deg)"}}/>
         <Decoration src={leave4} additionalStyles={{bottom: "15%", left: "-50px", width:  "24vw",  transform: "rotate(60deg)"}}/>
         </div>
      </div>
      </>
}